import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';

const CHANGE_SUBSCRIPTION_URL = '/payment/change-tenant-subscription/';

export const useChangeTenantSubscription = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const change = useCallback(
    async (data: { tariff: string }) => {
      return await executeRequest(() => axios.post(CHANGE_SUBSCRIPTION_URL, data));
    },
    [executeRequest]
  );

  return { loading, error, change };
};
